"use client";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useSyncExternalStore,
} from "react";
import {
  Box,
  Button,
  Divider,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  Skeleton,
  Tooltip,
  TooltipProps,
  Typography,
  styled,
  tooltipClasses,
  alpha,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import AddressCart from "../../address/AddressCart";
import Payment from "../payment/Payment";
import toast from "react-hot-toast";
import { AddToCartService, Cart, MainCart } from "../../../services/cart";
import { ApiService } from "../../../services/AppService";
import { getToken } from "../../../services/HolderService";
import { Address, ResponseObject, ServiceHub } from "../../../classes/main";
import { AddressInputDialog } from "../../address/AddressInputDialog";
import "./index.css";
import { Recommended } from "./Recommended";
import ToolTipInformation from "./ToolTipInformation";
import { FreeCoins } from "./FreeCoins";
import { PaymentSummeryDesktopView } from "./PaymentSummeryDesktopView";
import { CartLineItem } from "./CartLineItem";
import { OrderBreakdown } from "./OrderBreakdown";
import { AnimatePresence } from "framer-motion";
import Login from "../../login/Login";
import { Loader } from "../../genericComponents/MainLoader/Loader";
import MinimumPriceAlert from "./MinimumPriceAlert";
import { useCurrencyCode } from "../../genericComponents/helper-functions/CurrencySymbol";
import AllCarts from "./AllCarts";
import { useRouter } from "next/navigation";
import Link from "next/link";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import MaxServiceAlert from "../../genericComponents/card/MaxServiceAlert";
import Cookies from "js-cookie";
import ScheduleCartMobile from "../../genericComponents/date-and-time-picker/ScheduleCartMobile";
import PaymentMobile from "../payment/PaymentMobile";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ToolTipSafetyInfo from "../payment/ToolTipSafetyInfo";
import { RemoveServices } from "../../genericComponents/alert/RemoveServices";
import {
  CART_MINT,
  cartInteractiveRowSx,
  cartMobileHeaderSx,
  cartMobileLoginBarSx,
  cartOrderMainSurfaceSx,
  cartOutlinedAccentButtonSx,
  cartPreviewRowSx,
  cartStickyCheckoutBarInnerSx,
  cartStickyCheckoutBarOuterSx,
  cartCheckoutPanelSx,
  paymentPrimaryButtonSx,
} from "./cartUi";

interface CartUiProps {
  reloadCartService: any;
  setReloadCartService: any;
}

const CartUi: React.FC<CartUiProps> = ({
  reloadCartService,
  setReloadCartService,
}) => {
  const addToCartService = useMemo(() => new AddToCartService(), []);
  const [value, setValue] = React.useState(1);
  const [open, setOpen] = useState(false);
  const [openPaymentdialog, setOpenPaymentdialog] = useState(false);
  const [openMinimumPriceDialog, setOpenMinimumPriceDialog] = useState(false);
  const [openToolTipInfo, setOpenToolTipInfo] = useState(false);
  const [cart, setCart] = useState<Cart | null>(null);
  const [allCarts, setAllCarts] = useState<MainCart | null>(null);
  const [toolTipData, setToolTipData] = useState();
  const [calendar, setCalendar] = useState([]);
  const [address, setAddress] = useState(new Address());
  const [isAdressSaved, setIsAddressSaved] = useState(false);
  const [openDatePicker, setOpenDatePicker] = useState(false);
  const [openAllCarts, setOpenAllCarts] = useState(false);
  const [handleReschedule, setHandleReschedule] = useState(false);
  const [alreadyLogin, setAlreadyLogin] = useState(false);
  const [showLoginBox, setShowLoginBox] = useState(false);
  const [reloadCart, setReloadCart] = useState(false);
  const [updateAddress, setUpdateAddress] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [cid, setCid] = React.useState<number | null>(null);
  const [selectedDateSlot, setSelectedDateSlot] = useState();
  const [selectedTimeSlot, setSelectedTimeSlot] = useState();
  const [updateSlotsCartMobile, setUpdateSlotsCartMobile] = useState(false);
  const [skeltonLoaderPayment, setSkeltonLoaderPayment] = useState(false);
  const [openMaxService, setOpenMaxService] = useState(false);
  const [isLoading, setIsLoading] = useState<number | null>(null);
  const [disposableKit, setDisposableKit] = React.useState("1");
  const [openSafteyToolTipInfo, setOpenSafteyToolTipInfo] = useState(false);
  const [circularLoader, setCircularLoader] = React.useState(false);
  const [skeltonLoader, setSkeltonLoader] = React.useState(false);
  const [openRemoveServices, setOpenRemoveServices] = React.useState(false);
  const [removeServicesList, setRemoveServicesList] = React.useState<String[]>(
    []
  );
  const [unavailableServicesSid, setUnavailableServicesSid] = useState([]);
  const currencyCode = useCurrencyCode();
  const router = useRouter();
  const theme = useTheme();
  const mdMinPx = theme.breakpoints.values.md;
  /** SSR + hydration-safe: server and first client paint use `false`; then syncs to viewport. */
  const isDesktopCartLayout = useSyncExternalStore(
    (onChange) => {
      if (typeof window === "undefined") return () => {};
      const mq = window.matchMedia(`(min-width: ${mdMinPx}px)`);
      mq.addEventListener("change", onChange);
      return () => mq.removeEventListener("change", onChange);
    },
    () =>
      typeof window !== "undefined" &&
      window.matchMedia(`(min-width: ${mdMinPx}px)`).matches,
    () => false
  );
  const [token, setToken] = useState<string | null>(null);
  const apiService: ApiService = useMemo(() => new ApiService(), []);

  useEffect(() => {
    const localToken = getToken();
    setToken(localToken);
  }, []);

  useEffect(() => {
    if (!cart || !cart.cartItemRequests?.length) return;
    const checkServiceOnAddressChange = async () => {
      const address: Address = JSON.parse(
        atob(localStorage.getItem("address") as string)
      );
      const serviceHub: ServiceHub = JSON.parse(
        atob(localStorage.getItem("serviceHub") as string)
      );
      if (!address?.id) return;
      const payload = {
        addressId: address?.id?.toString(),
        cid: cid,
        hubId: serviceHub.id?.toString(),
        serviceCheckoutRequestList: cart?.cartItemRequests.map((item) => ({
          quantity: item?.count,
          sid: item?.sid,
        })),
      };

      try {
        const responseObject: ResponseObject | undefined =
          await apiService.post(
            apiService.checkServiceOnAddressChange,
            payload,
            getToken()!
          );
        const unavailableServices = responseObject?.object?.unavailableServices;
        if (unavailableServices?.length > 0) {
          setOpenRemoveServices(true);
          setUnavailableServicesSid(unavailableServices);
          const unavailableServiceName = cart?.cartItemRequests
            ?.filter((item) => unavailableServices.includes(item.sid))
            ?.map((item) => item.serviceName);
          setRemoveServicesList(unavailableServiceName);
        }
      } catch (error) {
        console.error("Error:", error);
      }
    };
    checkServiceOnAddressChange();
  }, [cart, address, cid, apiService]);

  const getInitializeCart = useCallback(() => {
    const mainCart = addToCartService.getCart();
    if (!mainCart) {
      return;
    }
    setAllCarts(mainCart);
    const cidFromLocal = localStorage.getItem("cid");
    if (!cidFromLocal) {
      const initCid = mainCart?.cartItemRequestsById[0]?.cid;
      setCid(initCid);
      const cartCidValid = mainCart?.cartItemRequestsById.find(
        (item: any) => item.cid === cid
      );
      setCart(cartCidValid);
      return;
    }
    const parsedCid = JSON.parse(atob(cidFromLocal));
    setCid(parsedCid);
    const cartCidValid = mainCart?.cartItemRequestsById.find(
      (item: any) => item.cid === cid
    );
    if (cartCidValid) {
      setCart(cartCidValid);
    } else {
      setCart(null);
      console.log(`No cart found for CID: ${parsedCid}`);
    }
  }, [addToCartService, cid]);

  React.useEffect(() => {
    getInitializeCart();
    const serviceHub: ServiceHub = JSON.parse(
      atob(localStorage.getItem("serviceHub") as string)
    ) as ServiceHub;
    if (cid) {
      apiService
        .post(
          apiService.calendar + "?hid=" + serviceHub.id + "&cid=" + cid,
          {},
          getToken()!
        )
        .then((value: unknown) => {
          const responseObject = value as ResponseObject;
          if (responseObject?.status == "success") {
            setCalendar(responseObject?.object?.calenders);
          }
        });
    }

    const savedAddress: Address = JSON.parse(
      atob(localStorage.getItem("address") as string)
    );
    setAddress(savedAddress);
    const value = localStorage.getItem("isAlreadyLogin");
    if (value && value == "true") {
      setAlreadyLogin(true);
      if (savedAddress.id == null || savedAddress.id == undefined) {
        setIsAddressSaved(true);
      }
    } else {
      setShowLoginBox(true);
    }
  }, [alreadyLogin, getInitializeCart, apiService, cid]);

  useEffect(() => {
    const savedAddress: Address = JSON.parse(
      atob(localStorage.getItem("address") as string)
    );
    setAddress(savedAddress);
    setUpdateAddress(false);
  }, [updateAddress]);

  useEffect(() => {
    getInitializeCart();
    setReloadCart(false);
    setReloadCartService(false);
  }, [
    value,
    reloadCart,
    reloadCartService,
    cid,
    setReloadCartService,
    getInitializeCart,
  ]);

  const handleSelectedAddress = (data: any) => {
    localStorage.setItem("address", btoa(JSON.stringify(data)));
    localStorage.setItem(
      "location",
      btoa(JSON.stringify(data?.geoJSON?.coordinates))
    );
    setAddress(data);
    setOpen(false);
  };

  const handleValueDecrease = async (
    sid: number,
    cid: number,
    url: any,
    item: any
  ) => {
    setIsLoading(sid);
    setCircularLoader(true);
    const claimServiceString = localStorage.getItem("claimService");
    const claimServiceBool = claimServiceString
      ? JSON.parse(atob(claimServiceString))
      : [];

    const isInCart = claimServiceBool?.some(
      (item: any) => item.inCart === true && item.id === sid
    );

    if (isInCart) {
      const updatedClaimService = claimServiceBool.map((item: any) =>
        item.id === sid ? { ...item, inCart: false } : item
      );
      await addToCartService.addToCart(
        sid,
        false,
        cid,
        url,
        item?.aboutList,
        item?.subHeading,
        item?.serviceCharge,
        item?.productCost,
        item?.min,
        item?.specialPrice,
        item?.specialMessage
      );
      setValue(Math.random());
      localStorage.setItem(
        "claimService",
        btoa(JSON.stringify(updatedClaimService))
      );
      setIsLoading(null);
      setCircularLoader(false);
    } else {
      await addToCartService.addToCart(
        sid,
        false,
        cid,
        url,
        item?.aboutList,
        item?.subHeading,
        item?.serviceCharge,
        item?.productCost,
        item?.min,
        item?.specialPrice,
        item?.specialMessage
      );
      setValue(Math.random());
      setIsLoading(null);
      setCircularLoader(false);
    }
    setUpdateSlotsCartMobile(true);
  };

  const handleValueIncrease = async (
    sid: number,
    cid: number,
    url: any,
    count: any,
    item: any
  ) => {
    setIsLoading(sid);
    setCircularLoader(true);
    const claimServiceString = localStorage.getItem("claimService");
    const claimServiceBool = claimServiceString
      ? JSON.parse(atob(claimServiceString))
      : [];

    const isInCart = claimServiceBool?.some(
      (item: any) => item.inCart === true && item.id === sid
    );
    if (isInCart) {
      alert("Opps ! You Can't add more than one free service");
    } else {
      await addToCartService.addToCart(
        sid,
        true,
        cid,
        url,
        item?.aboutList,
        item?.subHeading,
        item?.serviceCharge,
        item?.productCost,
        item?.min,
        item?.specialPrice,
        item?.specialMessage
      );
      setValue(Math.random());
      if (count == 5) {
        setOpenMaxService(true);
      }
      setIsLoading(null);
      setCircularLoader(false);
    }
    setUpdateSlotsCartMobile(true);
  };

  const handleOpenAddressDialog = () => {
    if (alreadyLogin) {
      setOpen(true);
    } else {
      setShowLoginBox(true);
    }
  };
  const handleCloseAddressDialog = () => {
    setOpen(false);
  };
  const setSelectedDate = (date: any) => {
    setSelectedDateSlot(date);
  };
  const setSelectedTime = (time: any) => {
    setSelectedTimeSlot(time);
  };
  const handleProceedButton = () => {
    if (cart && cart?.totalAmount > 480) {
      setOpenPaymentdialog(true);
    } else {
      setOpenMinimumPriceDialog(true);
    }
  };
  const handleProceedButtonMobile = () => {
    if (cart && cart?.totalAmount > 480) {
      setOpenDatePicker(true);
      setHandleReschedule(true);
    } else {
      setOpenMinimumPriceDialog(true);
    }
  };
  const handleClosePaymentDialog = () => {
    setOpenPaymentdialog(false);
  };
  const handleToolTipOpen = (data: any) => {
    setOpenToolTipInfo(true);
    setToolTipData(data);
  };
  const handleToolTipClose = () => {
    setOpenToolTipInfo(false);
  };
  const handleClosed = () => {
    setIsAddressSaved(false);
  };
  function handleUserLoggedIn() {
    localStorage.setItem("isAlreadyLogin", "true");
    Cookies.set("isAlreadyLogin", "true", {
      expires: 365,
      secure: true,
      sameSite: "Strict", // or 'Lax', depending on your use case
    });
    setAlreadyLogin(true);
    window.location.reload();
  }
  const handleToastNotification = () => {
    toast.success("Appointment Successfully Created", {
      duration: 5000,
      style: {
        padding: "16px",
      },
    });
  };

  const handleNavigate = (e: any) => {
    e.preventDefault(e);
    setLoading(true);
    router.push("/");
  };

  const handleDisposableChange = (event: SelectChangeEvent) => {
    setDisposableKit(event.target.value as string);
    setUpdateSlotsCartMobile(true);
  };

  const handleRemoveServices = async () => {
    await addToCartService.removeUnavailableServices(
      cid as number,
      unavailableServicesSid
    );
    getInitializeCart();
    setOpenRemoveServices(false);
  };

  const handleRemoveLineItem = async (item: any) => {
    if (!cart) return;
    let remaining = item.count;
    while (remaining > 0) {
      await handleValueDecrease(item.sid, cart.cid, item?.ImageUrl, item);
      remaining--;
    }
  };

  const handleMobileStickyPrimary = () => {
    if (!address?.id) {
      handleOpenAddressDialog();
      return;
    }
    document
      .getElementById("slots-mobile-view")
      ?.scrollIntoView({ behavior: "smooth", block: "center" });
  };

  const showMobileCheckoutBar =
    Boolean(token) &&
    Boolean(cart?.cartItemRequests?.length) &&
    alreadyLogin &&
    !selectedTimeSlot;

  const hasCartItems = Boolean(
    cart?.cartItemRequests && cart.cartItemRequests.length > 0
  );

  const BootstrapTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: CART_MINT,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: CART_MINT,
      color: "white",
    },
  }));

  return (
    <>
      {loading && <Loader />}
      <Box
        className="cart-page-shell"
        sx={{
          background: "transparent",
          width: "100%",
          maxWidth: "1280px",
          margin: "0 auto",
          minWidth: 0,
          padding: {
            xs: "10px 10px 20px",
            sm: "20px 24px 32px",
            md: "24px 32px 40px",
            lg: "28px 40px 48px",
          },
        }}
      >
        <Box sx={cartMobileHeaderSx}>
          <KeyboardBackspaceIcon
            sx={{
              background: "#fff",
              borderRadius: "12px",
              padding: "6px",
              fontSize: "26px",
              cursor: "pointer",
              color: "#0b1710",
              boxShadow: "0 4px 14px rgba(15, 23, 17, 0.1)",
              border: "1px solid rgba(31, 122, 77, 0.12)",
              display: { xs: "block", sm: "none" },
            }}
            onClick={handleNavigate}
            aria-label="Back to home"
          />
          <Typography
            variant="h6"
            sx={{
              color: "#0b1710",
              margin: "auto",
              fontWeight: 800,
              textAlign: "center",
              letterSpacing: "-0.02em",
              fontSize: "1.1rem",
            }}
          >
            Your cart
          </Typography>
        </Box>
        <Box
          sx={{
            display: { xs: "none", sm: "block" },
            mb: { sm: 1, md: 2 },
            maxWidth: "1280px",
            mx: "auto",
            px: { sm: 0, md: 0 },
            width: "100%",
            minWidth: 0,
          }}
        >
          <Recommended
            cartItems={cart}
            updateCartFlag={() => setReloadCart(true)}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "flex-start",
            gap: { xs: 1, sm: 2.5, md: 3 },
            margin: { xs: 0, sm: "0 auto" },
            paddingTop: { xs: "3.25rem", sm: 0 },
            paddingBottom: {
              xs: !hasCartItems
                ? "1.25rem"
                : showMobileCheckoutBar
                  ? "9.25rem"
                  : token &&
                      selectedTimeSlot &&
                      cart?.cartItemRequests &&
                      cart.cartItemRequests.length > 0
                    ? "1rem"
                    : "3.25rem",
              sm: 2,
              md: 0,
            },
            width: "100%",
            minWidth: 0,
          }}
        >
          {/* -----------Mobile View Start------------ */}
          {hasCartItems ? (
            <Box
              sx={{
                width: { xs: "100%", sm: "100%", md: "50%" },
                textAlign: "center",
                display: { xs: "block", sm: "none" },
              }}
            >
              <FreeCoins cart={cart} />
            </Box>
          ) : null}
          {/* -----------Mobile View Stop------------ */}

            <Box
              sx={{
                flex: { md: "1 1 0%" },
                minWidth: 0,
                minHeight: 0,
                width: "100%",
                padding: { xs: 0, sm: 0, md: 0 },
                pr: { sm: 1, md: 0 },
              }}
            >
            <Box
              sx={{
                ...cartOrderMainSurfaceSx,
                ...(hasCartItems
                  ? {}
                  : {
                      py: { xs: 0, sm: 0 },
                      boxShadow: { xs: "none", sm: "none" },
                      border: { xs: "none", sm: "none" },
                      bgcolor: { xs: "transparent", sm: "transparent" },
                    }),
              }}
            >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 1,
                px: { xs: 1, sm: 0 },
                pt: { xs: 0.5, sm: 0 },
                pb: { xs: 1.25, sm: 1.25 },
              }}
            >
              <Box>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 800,
                    fontSize: { xs: "1.35rem", sm: "1.6rem" },
                    letterSpacing: "-0.03em",
                    color: "#0b1710",
                  }}
                >
                  Order summary
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "text.secondary", mt: 0.35, display: { xs: "none", sm: "block" } }}
                >
                  Review services before booking your slot
                </Typography>
              </Box>
              {allCarts?.cartItemRequestsById?.length == 0 ||
              allCarts == null ||
              undefined ? (
                ""
              ) : (
                <Button
                  variant="outlined"
                  sx={cartOutlinedAccentButtonSx}
                  onClick={() => setOpenAllCarts(true)}
                >
                  View all carts
                </Button>
              )}
            </Box>
            <Box
              sx={{
                px: { xs: 1, sm: 0 },
                pr: { sm: 0.75 },
                pb: { xs: 0.5, sm: 0 },
                ...(hasCartItems
                  ? {
                      maxHeight: { xs: "none", sm: "47rem" },
                      overflow: { xs: "visible", sm: "auto" },
                    }
                  : {
                      minHeight: 0,
                      maxHeight: "none",
                      overflow: "visible",
                    }),
                "&::-webkit-scrollbar": {
                  width: 6,
                },
                "&::-webkit-scrollbar-thumb": {
                  borderRadius: 999,
                  background: alpha("#1f7a4d", 0.25),
                },
              }}
            >
              {cart?.cartItemRequests?.length == 0 || cart == null || undefined ? (
                <Box
                  sx={{
                    py: { xs: 3, sm: 6 },
                    px: { xs: 1.5, sm: 2 },
                    textAlign: "center",
                    borderRadius: "20px",
                    border: "1px dashed rgba(31, 122, 77, 0.25)",
                    background: alpha("#fff", 0.85),
                  }}
                >
                  <ShoppingBagOutlinedIcon
                    sx={{ fontSize: 52, color: alpha("#1f7a4d", 0.45), mb: 1.5 }}
                  />
                  <Typography variant="h6" fontWeight={800} color="#0b1710">
                    Your cart is empty
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 2.5, maxWidth: 320, mx: "auto" }}>
                    Add salon services from the home page, then return here to book your visit.
                  </Typography>
                  <Button
                    component={Link}
                    href="/"
                    variant="contained"
                    sx={{
                      ...paymentPrimaryButtonSx,
                      px: 3,
                      py: 1.25,
                    }}
                  >
                    Browse services
                  </Button>
                </Box>
              ) : (
                <AnimatePresence initial={false}>
                  {cart?.cartItemRequests
                    ?.sort((value1, value2) => value1.sid - value2.sid)
                    .map((item: any, index: number) => (
                      <Box
                        key={`${cart.cid}-${item.sid}-${index}`}
                        sx={{ mb: 1.5, width: "100%" }}
                      >
                        <CartLineItem
                          item={item}
                          currencyCode={currencyCode}
                          isLineLoading={isLoading === item.sid}
                          onDecrease={() =>
                            handleValueDecrease(
                              item.sid,
                              cart.cid,
                              item?.ImageUrl,
                              item
                            )
                          }
                          onIncrease={() =>
                            handleValueIncrease(
                              item.sid,
                              cart.cid,
                              item?.ImageUrl,
                              item?.count,
                              item
                            )
                          }
                          onRemove={() => handleRemoveLineItem(item)}
                          onInfo={() => handleToolTipOpen(item)}
                        />
                      </Box>
                    ))}
                </AnimatePresence>
              )}
              {/* -----------saftey kit----------------- */}
              {cart?.cartItemRequests?.length == 0 ||
              cart == null ||
              cart == undefined ? (
                ""
              ) : (
                <Box
                  sx={{
                    borderRadius: "16px",
                    width: "100%",
                    background: "#fff",
                    border: "1px solid rgba(31, 122, 77, 0.12)",
                    borderLeft: "4px solid #1f7a4d",
                    boxShadow: "0 10px 28px rgba(15, 23, 17, 0.06)",
                    marginBottom: "1rem",
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      padding: { xs: "12px 10px 10px", sm: "14px 12px 12px" },
                      width: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box
                        sx={{
                          display: "block",
                          justifyContent: "start",
                          alignItems: "center",
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "500" }}
                        >
                          Safety & Hygiene Kit &nbsp;
                          <BootstrapTooltip title="Information" placement="top">
                            <InfoOutlinedIcon
                              sx={{
                                color: CART_MINT,
                                cursor: "pointer",
                                fontSize: "19px",
                              }}
                              onClick={() => setOpenSafteyToolTipInfo(true)}
                            />
                          </BootstrapTooltip>
                        </Typography>
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: "bold" }}
                        >
                          {currencyCode}
                          {+disposableKit * 50}
                        </Typography>
                      </Box>
                      {/* -------------Dropdown--------- */}
                      <Box sx={{ minWidth: 70 }}>
                        <FormControl fullWidth>
                          {/* <InputLabel id="demo-simple-select-label">Age</InputLabel> */}
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={disposableKit}
                            // label="Age"
                            onChange={handleDisposableChange}
                            sx={{
                              borderRadius: "5rem",
                              backgroundColor: "#fff",
                              padding: 0, // removes inner padding
                              height: "32px", // set desired height
                              "& .MuiSelect-select": {
                                padding: "8px 16px", // fine-tune inner select padding
                              },
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderRadius: "5rem", // match border radius
                              },
                            }}
                          >
                            <MenuItem value={1}>1</MenuItem>
                            <MenuItem value={2}>2</MenuItem>
                            <MenuItem value={3}>3</MenuItem>
                            <MenuItem value={4}>4</MenuItem>
                            <MenuItem value={5}>5</MenuItem>
                          </Select>
                        </FormControl>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              )}
            </Box>
            {token &&
            cart &&
            hasCartItems &&
            !isDesktopCartLayout ? (
              <Box
                id="slots-mobile-view"
                sx={{
                  mt: { xs: 2.5, sm: 2.5 },
                  px: { xs: 1, sm: 0 },
                  minWidth: 0,
                  width: "100%",
                  maxWidth: "100%",
                }}
              >
                <ScheduleCartMobile
                  setSelectedTime={setSelectedTime}
                  setSelectedDate={setSelectedDate}
                  calender={calendar}
                  cid={cid}
                  setUpdateSlotsCartMobile={() => setUpdateSlotsCartMobile(true)}
                  setSkeltonLoaderPayment={() => setSkeltonLoaderPayment(true)}
                  skeltonLoader={skeltonLoader}
                  setSkeltonLoader={(value: any) => setSkeltonLoader(value)}
                />
              </Box>
            ) : null}
            </Box>
          </Box>
          {/* -----------recomended mobile----------------- */}
          <Box
            sx={{
              display: { xs: "block", sm: "none" },
              width: "100%",
              minWidth: 0,
              maxWidth: "100%",
            }}
          >
            <Recommended
              cartItems={cart}
              updateCartFlag={() => setReloadCart(true)}
            />
          </Box>
          {/* -------------- desktop view payment summery ---------------- */}
          <Box
            sx={{
              flex: { md: "0 0 400px" },
              width: { xs: "100%", md: "400px" },
              maxWidth: "100%",
              textAlign: "left",
              display: { xs: "none", sm: "block" },
              position: { md: "sticky" },
              top: { md: 24 },
              alignSelf: "flex-start",
              ...cartCheckoutPanelSx,
            }}
          >
            <PaymentSummeryDesktopView cart={cart} />
            <FreeCoins cart={cart} />
            <Divider sx={{ my: 2, borderColor: alpha(CART_MINT, 0.12) }} />
            <Typography
              variant="caption"
              fontWeight={800}
              color="text.secondary"
              sx={{ letterSpacing: "0.04em", textTransform: "uppercase", display: "block", mb: 0.5 }}
            >
              Delivery address
            </Typography>
            <Box sx={cartInteractiveRowSx} onClick={handleOpenAddressDialog}>
              <Box sx={{ display: "flex", gap: 1.25, minWidth: 0, flex: 1 }}>
                <LocationOnOutlinedIcon sx={{ color: CART_MINT, flexShrink: 0, mt: 0.15 }} />
                <Box sx={{ minWidth: 0, textAlign: "left" }}>
                  <Typography variant="body2" fontWeight={600} color="#0b1710">
                    {address?.building || address?.locality || address?.formattedAddress
                      ? "Service location"
                      : "Add your address"}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                    {address?.building}&nbsp;
                    {address?.locality}&nbsp;
                    {address?.formattedAddress}
                  </Typography>
                </Box>
              </Box>
              <ChevronRightIcon sx={{ color: CART_MINT, flexShrink: 0 }} />
            </Box>
            {!address?.id ? (
              <Typography variant="caption" sx={{ color: "error.main", display: "block", mt: 0.5, px: 0.5 }}>
                Select an address to continue
              </Typography>
            ) : null}
            <Divider sx={{ my: 2, borderColor: alpha(CART_MINT, 0.12) }} />
            <Typography
              variant="caption"
              fontWeight={800}
              color="text.secondary"
              sx={{ letterSpacing: "0.04em", textTransform: "uppercase", display: "block", mb: 0.5 }}
            >
              Date &amp; time
            </Typography>
            <Box sx={cartPreviewRowSx}>
              <Box sx={{ display: "flex", gap: 1.25, minWidth: 0, flex: 1 }}>
                <EventOutlinedIcon sx={{ color: CART_MINT, flexShrink: 0, mt: 0.15 }} />
                <Box sx={{ textAlign: "left" }}>
                  {!selectedDateSlot || !selectedTimeSlot ? (
                    <Typography variant="body2" sx={{ color: "error.main", fontWeight: 600 }}>
                      Pick date &amp; time below
                    </Typography>
                  ) : (
                    <>
                      <Typography variant="body2" fontWeight={700} color="#0b1710">
                        {selectedDateSlot}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {selectedTimeSlot}
                      </Typography>
                    </>
                  )}
                </Box>
              </Box>
            </Box>
            {!isDesktopCartLayout ? (
              skeltonLoader ? (
                <Skeleton
                  variant="rounded"
                  width="100%"
                  height={40}
                  animation="wave"
                  sx={{ margin: "2rem auto" }}
                />
              ) : (
                <Button
                  variant="contained"
                  sx={{
                    ...paymentPrimaryButtonSx,
                    margin: "2rem 0px",
                    width: "100%",
                  }}
                  onClick={
                    alreadyLogin ? handleProceedButton : handleOpenAddressDialog
                  }
                  disabled={
                    cart?.cartItemRequests?.length == 0 ||
                    cart == null ||
                    cart == undefined ||
                    !address?.id ||
                    !selectedDateSlot ||
                    !selectedTimeSlot
                  }
                >
                  Proceed to checkout
                </Button>
              )
            ) : null}
            {openPaymentdialog && (
              <Payment
                openPaymentdialog={openPaymentdialog}
                handleClosePaymentDialog={handleClosePaymentDialog}
                setLoading={setLoading}
                stopSetLoading={() => setLoading(false)}
                cid={cid}
                disposableKitCount={disposableKit}
                circularLoader={circularLoader}
                setCircularLoader={(value: any) => setCircularLoader(value)}
              />
            )}
            {openMinimumPriceDialog && (
              <MinimumPriceAlert
                openInfo={openMinimumPriceDialog}
                handleClose={() => setOpenMinimumPriceDialog(false)}
              />
            )}
          </Box>
        </Box>
        {token &&
          cart &&
          hasCartItems &&
          isDesktopCartLayout ? (
          <Box
            id="slots-desktop-view"
            sx={{
              width: "100%",
              maxWidth: "1280px",
              mx: "auto",
              px: 0,
              mt: { md: 3 },
              mb: { md: 0 },
              pb: { md: 5 },
              minWidth: 0,
            }}
          >
            <ScheduleCartMobile
              setSelectedTime={setSelectedTime}
              setSelectedDate={setSelectedDate}
              calender={calendar}
              cid={cid}
              setUpdateSlotsCartMobile={() => setUpdateSlotsCartMobile(true)}
              setSkeltonLoaderPayment={() => setSkeltonLoaderPayment(true)}
              skeltonLoader={skeltonLoader}
              setSkeltonLoader={(value: any) => setSkeltonLoader(value)}
            />
            {skeltonLoader ? (
              <Skeleton
                variant="rounded"
                width="100%"
                height={48}
                animation="wave"
                sx={{ mt: { md: 2.5 } }}
              />
            ) : (
              <Button
                variant="contained"
                sx={{
                  ...paymentPrimaryButtonSx,
                  mt: { md: 2.5 },
                  width: "100%",
                }}
                onClick={
                  alreadyLogin ? handleProceedButton : handleOpenAddressDialog
                }
                disabled={
                  cart?.cartItemRequests?.length == 0 ||
                  cart == null ||
                  cart == undefined ||
                  !address?.id ||
                  !selectedDateSlot ||
                  !selectedTimeSlot
                }
              >
                Proceed to checkout
              </Button>
            )}
          </Box>
        ) : null}
        {!token && cart && cart?.cartItemRequests?.length > 0 ? (
            <Box sx={{ display: { xs: "block", sm: "none" } }}>
              <Box sx={cartMobileLoginBarSx}>
                <Button
                  sx={{
                    ...paymentPrimaryButtonSx,
                    width: "100%",
                  }}
                  variant="contained"
                  onClick={() => setShowLoginBox(true)}
                >
                  Log in to continue
                </Button>
              </Box>
            </Box>
          ) : null}

          {showMobileCheckoutBar && (
            <Box sx={cartStickyCheckoutBarOuterSx}>
              <Box sx={cartStickyCheckoutBarInnerSx}>
                <OrderBreakdown
                  cart={cart}
                  currencyCode={currencyCode}
                  variant="compact"
                />
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleMobileStickyPrimary}
                  sx={{
                    ...paymentPrimaryButtonSx,
                    mt: 1.5,
                  }}
                >
                  {!address?.id
                    ? "Add delivery address"
                    : "Choose date & time"}
                </Button>
              </Box>
            </Box>
          )}

          <Box sx={{ display: { xs: "block", sm: "none" } }}>
            {token &&
              selectedTimeSlot &&
              cart &&
              cart?.cartItemRequests?.length > 0 && (
                <PaymentMobile
                  setLoading={setLoading}
                  stopSetLoading={() => setLoading(false)}
                  cid={cid}
                  updateSlotsCartMobile={updateSlotsCartMobile}
                  setUpdateSlotsCartMobile={() =>
                    setUpdateSlotsCartMobile(false)
                  }
                  disposableKitCount={disposableKit}
                  circularLoader={circularLoader}
                  setCircularLoader={(value: any) => setCircularLoader(value)}
                  skeltonLoaderPayment={skeltonLoaderPayment}
                  setSkeltonLoaderPayment={() => setSkeltonLoaderPayment(false)}
                />
              )}
          </Box>
          <ToolTipInformation
            openInfo={openToolTipInfo}
            handleClose={handleToolTipClose}
            data={toolTipData}
          />
          <AddressCart
            open={open}
            handleCloseAddressDialog={handleCloseAddressDialog}
            isAddressFromProductCart={true}
            handleOpenProductConfirmDialog={handleSelectedAddress}
            addressForSave={address}
          />
          {address != null &&
          address != undefined &&
          address.formattedAddress != null ? (
            <AddressInputDialog
              addressOpen={isAdressSaved}
              addressForSave={address}
              handleClose={handleClosed}
              updateAddressList={() => setUpdateAddress(true)}
              updateAddressFlag={false}
            ></AddressInputDialog>
          ) : (
            <div></div>
          )}
          <Login
            showLoginBox={showLoginBox}
            handleLoginClose={() => setShowLoginBox(false)}
            handleUserLoggedIn={handleUserLoggedIn}
          />
          <AllCarts
            openAllCarts={openAllCarts}
            handleCloseAllCarts={() => setOpenAllCarts(false)}
            allCarts={allCarts}
            changedCid={(clickedCid: any) => setCid(clickedCid)}
          />
        {/* <FreeGifts /> */}
        <MaxServiceAlert
          openInfo={openMaxService}
          handleClose={() => setOpenMaxService(false)}
        />
        <ToolTipSafetyInfo
          openInfo={openSafteyToolTipInfo}
          handleClose={() => setOpenSafteyToolTipInfo(false)}
        />
        <RemoveServices
          open={openRemoveServices}
          services={removeServicesList}
          onRemove={handleRemoveServices}
        />
      </Box>
    </>
  );
};

export default CartUi;
